import styled from 'styled-components';
import Colors from 'pubweb-smokey/dist/colors';
import * as variables from 'pubweb-smokey/dist/components/GridSystem/_vars_widths';

export const HomeCardStyles = styled.div`
  a {
    text-decoration: none;
  }
  .card-image-area {
    position: relative;
    width: 100%;
    left: 0;
    border-radius: 6px;
    overflow: hidden;

    margin-bottom: 13px;
    &.card-slideshow {
      margin-bottom: 5px;
    }

    .aspect-ratio-sizer {
      width: 100%;
    }
    & .carousel-root {
      position: absolute;
      top: 0;
    }
    .card-image-single img {
      border-radius: 6px;
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      min-height: 100%;
    }

    .sticker-container {
      position: absolute;
      top: 10px;
      left: 10px;
      display: flex;
      flex-wrap: wrap;
      z-index: 2;

      .sticker {
        background-color: ${Colors.secondary.grey6.standard};
        border-radius: 30px;
        color: ${Colors.primary.black.standard};
        padding: 4px 7px;
        margin-right: 7px;
        margin-bottom: 5px;

        .in-stock-dot {
          background-color: ${Colors.secondary.kiddiePool.standard};
        }
        .sticker-dot {
          width: 6px;
          height: 6px;
          border-radius: 50%;
          margin: 4px 3px 4px 2px;
          float: left;
        }
      }
    }

    .favoriting-heart-container-card {
      position: absolute;
      top: 5px;
      right: ${(props) => (props.$useSlideshow ? '20px' : '5px')};
    }
  }

  .card-info-area {
    display: flex;
    justify-content: space-between;
    width: 100%;

    .card-heading,
    .card-home-specs {
      margin: 0;
    }
    .price {
      color: ${Colors.primary.black.standard};
      text-align: right;
      margin-top: -3px;

      .label {
        margin: 0;
        padding: 0;
      }
      .intro {
        margin-top: -3px;
      }
    }
  }
  .carousel-root {
    height: 100%;
    .carousel {
      border-radius: 6px;

      .control-arrow {
        padding: 2px !important; /* override for carousel */
        background-color: rgba(78, 82, 85, 0.2)
          /* ${Colors.accent.grey1.standard} */ !important;
        opacity: 1 !important /* forcibly overwriting react-responsive-carousel's own styling */;
      }

      .slider-wrapper {
        /* Slight zoom in so that the image fits in the full container (Sometimes horizontal images don't fit as intended.) */
        transform: scale(1.15);

        /* Overrides the element style forced upon it by react-responsive-carousel. Forgive me for my transgressions. */
        height: ${(props) => props.$adjustedHeight + 'px'} !important;

        .slide {
          background-color: ${Colors.secondary.grey6.standard};
          border-radius: 6px;
          div {
            img {
              max-height: ${(props) => props.$adjustedHeight + 'px'};
              object-fit: contain;
            }
          }
        }
      }

      .thumbs-wrapper {
        margin: 10px 0;
        .thumb {
          border: none;
          max-height: 80px;
          padding: 0;

          &.selected {
            border: solid 2px black;
          }
        }
      }
    }
  }

  @media only screen and (min-width: ${variables.desktop_breakpoint}px) {
    position: relative;

    .carousel {
      .slide {
        img {
          width: 100%;
        }
      }
    }
  }
`;
